import { create } from 'zustand';
import { loginTeacher } from '../api';

const useAdminAuthStore = create((set) => ({
  admin: null, // { teacherId, fullName, isAdmin }
  token: null,
  loading: false,
  error: null,

  init() {
    const token = localStorage.getItem('adminToken');
    const admin = localStorage.getItem('adminUser');
    if (token && admin) {
      set({ token, admin: JSON.parse(admin) });
    }
  },

  async login({ login, password }) {
    set({ loading: true, error: null });
    try {
      const data = await loginTeacher({ login, password });
      if (!data.isAdmin) throw new Error('Нет прав администратора');
      set({ admin: { teacherId: data.teacherId, fullName: data.fullName, isAdmin: true }, token: data.token, loading: false });
      localStorage.setItem('adminToken', data.token);
      localStorage.setItem('adminUser', JSON.stringify({ teacherId: data.teacherId, fullName: data.fullName, isAdmin: true }));
      return true;
    } catch (e) {
      set({ error: e.message, loading: false });
      return false;
    }
  },

  logout() {
    set({ admin: null, token: null });
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
  },
}));

export default useAdminAuthStore; 